import { useWatch } from 'react-hook-form';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface TabProps {
  formMode: FormMode;
}

export function TyGiaTab({ formMode }: TabProps) {
  const [ma_ngv] = useWatch({ name: ['ma_ngv'] });
  return (
    <div className='space-y-5 p-4'>
      <div className='flex items-center'>
        <Label className='w-44 font-medium' htmlFor='tg_dd'>
          Sửa tỷ giá ghi sổ
        </Label>
        <FormFieldV2 type='checkbox' name='tg_dd' disabled={formMode === 'view' || ma_ngv === '2'} />
      </div>
      {ma_ngv === '2' && (
        <div className='flex items-center font-medium'>
          <Label className='w-44' htmlFor='ty_gia'>
            Tạo chênh lệch tỷ giá
          </Label>
          <FormFieldV2 type='checkbox' name='cltg_yn' disabled={formMode === 'view'} />
        </div>
      )}
    </div>
  );
}
